export const transformInfoBoardPostDto = dto => ({
  id: dto.id,
  title: dto.title,
  subtitle: dto.subtitle,
  body: dto.body,
  layoutType: dto.layout_type
});
export const transformInfoBoardPostDtos = dtos => dtos.map(transformInfoBoardPostDto);